import React, { useState, useEffect } from "react";

const RegisterSetting = ({ cartCheckData, handleSave }) => {
    const [email, setCouponApply] = useState(true);
    const [phone, setCoinApply] = useState(true);

    useEffect(() => {
        if (cartCheckData) {
            setCouponApply(
                cartCheckData.email !== undefined
                    ? cartCheckData.email
                    : true
            );
            setCoinApply(
                cartCheckData.phone !== undefined
                    ? cartCheckData.phone
                    : true
            );
        }
    }, [cartCheckData]);

    const onSave = () => {
        handleSave({
            email: email,
            phone: phone
        });
    };

    return (
        <div className="gst-setting-container">
            <label className="gst-setting-label">
                Register Settings
            </label>

            <div className="flex gap-6 mt-3">
                <label className="flex items-center gap-2 cursor-pointer">
                    <input
                        type="checkbox"
                        checked={email}
                        onChange={(e) => setCouponApply(e.target.checked)}
                    />
                    Email
                </label>

                <label className="flex items-center gap-2 cursor-pointer">
                    <input
                        type="checkbox"
                        checked={phone}
                        onChange={(e) => setCoinApply(e.target.checked)}
                    />
                    Mobile
                </label>
            </div>

            <button
                className="gst-setting-save-btn mt-4"
                onClick={onSave}
            >
                Save
            </button>
        </div>
    );
};

export default RegisterSetting;
